import styled from 'styled-components';

const Wrapper = styled.main`
  /* ── RESET / BASE ── */
  * { box-sizing: border-box; }

  /* ── NAVBAR ── */
  .navbar {
    position: sticky;
    top: 0;
    z-index: 100;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid #f1f5f9;
  }
  .nav-container {
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 2rem;
    height: 64px;
    display: flex;
    align-items: center;
    gap: 2rem;
  }
  .nav-logo {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    text-decoration: none;
  }
  .nav-logo-icon {
    width: 30px;
    height: 30px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
  }
  .nav-logo-text {
    font-size: 1.05rem;
    font-weight: 700;
    color: #0f172a;
    letter-spacing: -0.02em;
  }
  .nav-links {
    display: none;
    align-items: center;
    gap: 0.25rem;
    margin-left: auto;
    @media (min-width: 768px) {
      display: flex;
    }
  }
  .nav-link {
    font-size: 0.875rem;
    font-weight: 500;
    color: #475569;
    text-decoration: none;
    padding: 0.4rem 0.75rem;
    border-radius: 6px;
    transition: color 0.15s, background 0.15s;
    &:hover {
      color: #0f172a;
      background: #f1f5f9;
    }
  }
  .nav-cta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-left: auto;
    @media (min-width: 768px) {
      margin-left: 1.5rem;
    }
  }
  .btn-nav-ghost {
    font-size: 0.875rem;
    font-weight: 500;
    color: #475569;
    text-decoration: none;
    padding: 0.4rem 0.875rem;
    border-radius: 7px;
    transition: color 0.15s, background 0.15s;
    &:hover { color: #0f172a; background: #f1f5f9; }
  }
  .btn-nav-solid {
    font-size: 0.875rem;
    font-weight: 600;
    color: #fff;
    text-decoration: none;
    padding: 0.45rem 1rem;
    border-radius: 7px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    display: flex;
    align-items: center;
    gap: 0.35rem;
    transition: opacity 0.15s, transform 0.15s;
    &:hover { opacity: 0.9; transform: translateY(-1px); }
  }

  /* ── HERO ── */
  .hero {
    background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%);
    padding: 5rem 0 4rem;
    position: relative;
    overflow: hidden;
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: radial-gradient(ellipse 80% 60% at 50% 0%, rgba(99, 102, 241, 0.18) 0%, transparent 70%);
      pointer-events: none;
    }
  }
  .hero-container {
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 2rem;
    display: grid;
    gap: 3rem;
    align-items: center;
    @media (min-width: 900px) {
      grid-template-columns: 1fr 1fr;
    }
  }
  .hero-content { display: flex; flex-direction: column; gap: 1.5rem; }
  .hero-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: #a5b4fc;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(99, 102, 241, 0.3);
    padding: 0.35rem 0.75rem;
    border-radius: 100px;
    width: fit-content;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .hero-title {
    font-size: clamp(2.2rem, 5vw, 3.25rem);
    font-weight: 800;
    color: #f8fafc;
    line-height: 1.15;
    letter-spacing: -0.03em;
    margin: 0;
  }
  .hero-em {
    font-style: normal;
    background: linear-gradient(90deg, #818cf8, #c084fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .hero-desc {
    font-size: 1.05rem;
    line-height: 1.7;
    color: #94a3b8;
    margin: 0;
    max-width: 480px;
  }
  .hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
  }
  .btn-primary {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.95rem;
    font-weight: 700;
    color: #fff;
    text-decoration: none;
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.4);
    transition: transform 0.15s, box-shadow 0.15s;
    &:hover { transform: translateY(-2px); box-shadow: 0 6px 28px rgba(99, 102, 241, 0.5); }
  }
  .btn-secondary {
    display: inline-flex;
    align-items: center;
    font-size: 0.95rem;
    font-weight: 600;
    color: #cbd5e1;
    text-decoration: none;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    border: 1px solid rgba(203, 213, 225, 0.2);
    background: rgba(255, 255, 255, 0.06);
    transition: background 0.15s, color 0.15s;
    &:hover { background: rgba(255, 255, 255, 0.1); color: #fff; }
  }
  .hero-trust {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  .trust-stars {
    display: flex;
    gap: 1px;
    color: #fbbf24;
  }
  .trust-text {
    font-size: 0.82rem;
    color: #64748b;
  }

  /* ── APP PREVIEW MOCKUP ── */
  .hero-visual {
    display: flex;
    justify-content: center;
  }
  .app-preview {
    width: 100%;
    max-width: 400px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 16px;
    overflow: hidden;
    backdrop-filter: blur(20px);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255,255,255,0.05);
  }
  .preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.25rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  }
  .preview-header-left {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.85rem;
    font-weight: 600;
    color: #e2e8f0;
  }
  .preview-badge {
    font-size: 0.72rem;
    font-weight: 600;
    color: #818cf8;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(99, 102, 241, 0.25);
    padding: 0.2rem 0.55rem;
    border-radius: 100px;
  }
  .preview-list {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .preview-job {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.85rem 1.25rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    transition: background 0.15s;
    &:last-child { border-bottom: none; }
    &:hover { background: rgba(255, 255, 255, 0.04); }
  }
  .job-avatar {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }
  .job-info {
    display: flex;
    flex-direction: column;
    gap: 0.1rem;
    flex: 1;
    min-width: 0;
  }
  .job-company {
    font-size: 0.82rem;
    font-weight: 600;
    color: #e2e8f0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .job-role {
    font-size: 0.74rem;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .job-right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.2rem;
    flex-shrink: 0;
  }
  .job-time {
    font-size: 0.7rem;
    color: #475569;
  }
  .job-status {
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.15rem 0.5rem;
    border-radius: 100px;
  }
  .preview-footer {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    padding: 0.85rem 1.25rem;
    font-size: 0.78rem;
    color: #818cf8;
    background: rgba(99, 102, 241, 0.07);
    border-top: 1px solid rgba(99, 102, 241, 0.15);
  }

  /* ── STATS BAR ── */
  .stats-bar {
    background: #fff;
    border-bottom: 1px solid #f1f5f9;
    padding: 2rem 0;
  }
  .stats-container {
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem 0;
  }
  .stats-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.2rem;
    padding: 0 2.5rem;
  }
  .stats-num {
    font-size: 1.6rem;
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.03em;
  }
  .stats-label {
    font-size: 0.8rem;
    color: #94a3b8;
    font-weight: 500;
  }
  .stats-sep {
    width: 1px;
    height: 2.5rem;
    background: #e2e8f0;
  }

  /* ── SHARED SECTION STYLES ── */
  .section {
    padding: 5rem 0;
  }
  .section-container {
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 2rem;
  }
  .section-header {
    text-align: center;
    max-width: 560px;
    margin: 0 auto 3rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
  .section-tag {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6366f1;
  }
  .section-title {
    font-size: clamp(1.6rem, 3.5vw, 2.25rem);
    font-weight: 800;
    color: #0f172a;
    letter-spacing: -0.03em;
    margin: 0;
    line-height: 1.2;
  }
  .section-desc {
    font-size: 0.95rem;
    color: #64748b;
    line-height: 1.7;
    margin: 0;
  }

  /* ── HOW IT WORKS ── */
  .how-it-works {
    background: #f8fafc;
  }
  .steps-grid {
    display: grid;
    gap: 1.5rem;
    @media (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .step-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 2rem 1.75rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    position: relative;
    transition: box-shadow 0.2s, transform 0.2s;
    &:hover {
      box-shadow: 0 8px 30px rgba(15, 23, 42, 0.08);
      transform: translateY(-3px);
    }
  }
  .step-featured {
    border-color: #c7d2fe;
    background: linear-gradient(160deg, #eef2ff, #fff);
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.1);
  }
  .step-num {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: #94a3b8;
  }
  .step-icon-wrap {
    width: 52px;
    height: 52px;
    background: #f1f5f9;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6366f1;
  }
  .step-icon-featured {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
  }
  .step-title {
    font-size: 1rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
  }
  .step-desc {
    font-size: 0.875rem;
    color: #64748b;
    line-height: 1.65;
    margin: 0;
  }

  /* ── FEATURES ── */
  .features-section {
    background: #fff;
  }
  .features-grid {
    display: grid;
    gap: 1.25rem;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
  .feature-card {
    padding: 1.75rem;
    border: 1px solid #f1f5f9;
    border-radius: 14px;
    background: #fcfcfd;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    transition: box-shadow 0.2s, transform 0.2s, border-color 0.2s;
    &:hover {
      box-shadow: 0 6px 24px rgba(15, 23, 42, 0.07);
      transform: translateY(-2px);
      border-color: #e2e8f0;
    }
  }
  .feature-icon-wrap {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon-indigo { background: #eef2ff; color: #6366f1; }
  .icon-emerald { background: #d1fae5; color: #059669; }
  .icon-amber { background: #fef3c7; color: #d97706; }
  .icon-violet { background: #ede9fe; color: #7c3aed; }
  .icon-rose { background: #fee2e2; color: #dc2626; }
  .icon-teal { background: #ccfbf1; color: #0d9488; }

  .feature-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
  }
  .feature-desc {
    font-size: 0.85rem;
    color: #64748b;
    line-height: 1.65;
    margin: 0;
  }

  /* ── TESTIMONIALS ── */
  .testimonials {
    background: #f8fafc;
    padding: 5rem 0;
  }
  .testimonial-grid {
    display: grid;
    gap: 1.25rem;
    @media (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
  .testimonial-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 1.75rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    transition: box-shadow 0.2s;
    &:hover { box-shadow: 0 6px 24px rgba(15, 23, 42, 0.07); }
  }
  .testi-stars {
    display: flex;
    gap: 2px;
    color: #fbbf24;
  }
  .testi-quote {
    font-size: 0.9rem;
    color: #334155;
    line-height: 1.7;
    margin: 0;
    flex: 1;
  }
  .testi-author {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
  .testi-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
  }
  .testi-name {
    display: block;
    font-size: 0.85rem;
    font-weight: 700;
    color: #0f172a;
  }
  .testi-role {
    display: block;
    font-size: 0.75rem;
    color: #94a3b8;
  }

  /* ── CTA ── */
  .cta-section {
    padding: 5rem 0;
    background: linear-gradient(160deg, #0f172a 0%, #1e1b4b 100%);
  }
  .cta-box {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
    padding: 0 1rem;
  }
  .cta-stars {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    color: #fbbf24;
  }
  .cta-rating {
    font-size: 0.82rem;
    color: #64748b;
    margin-left: 0.25rem;
  }
  .cta-title {
    font-size: clamp(1.75rem, 4vw, 2.75rem);
    font-weight: 800;
    color: #f8fafc;
    letter-spacing: -0.03em;
    line-height: 1.2;
    margin: 0;
  }
  .cta-desc {
    font-size: 1rem;
    color: #94a3b8;
    max-width: 440px;
    line-height: 1.7;
    margin: 0;
  }
  .btn-cta {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1rem;
    font-weight: 700;
    color: #fff;
    text-decoration: none;
    padding: 0.875rem 2rem;
    border-radius: 12px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    box-shadow: 0 4px 24px rgba(99, 102, 241, 0.45);
    transition: transform 0.15s, box-shadow 0.15s;
    &:hover { transform: translateY(-2px); box-shadow: 0 8px 32px rgba(99, 102, 241, 0.55); }
  }
  .cta-note {
    font-size: 0.8rem;
    color: #475569;
    margin: 0;
  }

  /* ── FOOTER ── */
  .footer {
    background: #0a0f1e;
    padding: 1.75rem 0;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
  }
  .footer-container {
    max-width: 1120px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 1rem;
  }
  .footer-brand {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    font-weight: 700;
    color: #e2e8f0;
  }
  .footer-logo-icon {
    width: 26px;
    height: 26px;
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .footer-copy {
    font-size: 0.8rem;
    color: #475569;
    margin: 0;
  }
  .footer-links {
    display: flex;
    gap: 1rem;
  }
  .footer-link {
    font-size: 0.8rem;
    color: #475569;
    text-decoration: none;
    transition: color 0.15s;
    &:hover { color: #94a3b8; }
  }
`;

export default Wrapper;
